import { defineComponent as H, openBlock as t, createElementBlock as l, mergeProps as i, unref as o, renderSlot as p, createElementVNode as e, createCommentVNode as u } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, g = { key: 1 }, A = { key: 2 }, Z = { key: 3 }, f = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconSignOut"
}, _ = /* @__PURE__ */ H({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: h, weight: n } = m(s);
    return (d, a) => (t(), l("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(h)), [
      p(d.$slots, "default"),
      o(n) === "bold" ? (t(), l("g", V, a[0] || (a[0] = [
        e("path", { d: "M124,216a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V40A12,12,0,0,1,48,28h64a12,12,0,0,1,0,24H60V204h52A12,12,0,0,1,124,216Zm108.49-96.49-40-40a12,12,0,0,0-17,17L195,116H112a12,12,0,0,0,0,24h83l-19.52,19.51a12,12,0,0,0,17,17l40-40A12,12,0,0,0,232.49,119.51Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), l("g", g, a[1] || (a[1] = [
        e("path", {
          d: "M224,56V200a16,16,0,0,1-16,16H48V40H208A16,16,0,0,1,224,56Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), l("g", A, a[2] || (a[2] = [
        e("path", { d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40A8,8,0,0,0,176,88v32H112a8,8,0,0,0,0,16h64v32a8,8,0,0,0,13.66,5.66l40-40A8,8,0,0,0,229.66,122.34Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), l("g", Z, a[3] || (a[3] = [
        e("path", { d: "M118,216a6,6,0,0,1-6,6H48a6,6,0,0,1-6-6V40a6,6,0,0,1,6-6h64a6,6,0,0,1,0,12H54V210h58A6,6,0,0,1,118,216Zm110.24-92.24-40-40a6,6,0,0,0-8.48,8.48L209.51,122H112a6,6,0,0,0,0,12h97.51l-29.75,29.76a6,6,0,1,0,8.48,8.48l40-40A6,6,0,0,0,228.24,123.76Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), l("g", f, a[4] || (a[4] = [
        e("path", { d: "M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), l("g", k, a[5] || (a[5] = [
        e("path", { d: "M116,216a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h64a4,4,0,0,1,0,8H52V212h60A4,4,0,0,1,116,216Zm110.83-90.83-40-40a4,4,0,0,0-5.66,5.66L214.34,124H112a4,4,0,0,0,0,8H214.34l-33.17,33.17a4,4,0,0,0,5.66,5.66l40-40A4,4,0,0,0,226.83,125.17Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  _ as default
};
